module.exports = __webpack_public_path__ + "26d642d1ff87af2b48fcbb7246d26dc4.svg";